import { refDebounced } from '@vueuse/core'
import { computed, ref, useId } from 'vue'

/**
 * Recherche de localités (nom de commune ou code postal) via `/localites`, déclenchée
 * après une pause de frappe. Les suggestions sont des `LocaliteItem` (`label` au format
 * `codePostal nom`, `parent` pour une ancienne commune ou une commune déléguée).
 */
export function useLocaliteSearch() {
  const searchTerm = ref('')
  const debouncedSearchTerm = refDebounced(searchTerm, 300)

  // `key` explicite : `useApi` dérive sinon sa clé du site d'appel, ce qui ferait
  // partager le même cache/état entre toutes les instances de ce composable
  // (ex: Sidebar.vue et SidebarDiffusion.vue montés simultanément).
  const { data: localites } = useApi('/localites', {
    key: `localite-search-${useId()}`,
    query: { search: debouncedSearchTerm },
    watch: [debouncedSearchTerm],
    default: () => [],
  })

  const items = computed(() => toLocaliteItems(localites.value))

  return { searchTerm, items }
}
